<template lang="pug">
  div.md-Popover
    div.md-Popover_Box(:data-arrow="dataArrow")
      div.md-Popover_Close(v-if="canClose", @click="close") ×
      slot
</template>
<script>
  import eventListener from '../mixins/eventListener';

  export default {
    mixins: [eventListener],
    props: {
      canClose: { type: Boolean, default: true },
      dataArrow: { type: String, default: 'bottom-left' },
      outerClose: { type: Boolean, default: true },
    },
    mounted() {
      this.$listen(window, 'click', (e) => {
        if (!this.$el.contains(e.target) && this.outerClose) {
          this.close();
        }
      });
    },
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>
